/**
 * Time entry categories as defined in SRS FR-PUNCH-03.
 */
export const CATEGORIES = [
  { id: 'operational', label: 'Operational' },
  { id: 'administrative', label: 'Administrative' },
  { id: 'training', label: 'Training' },
  { id: 'public_event', label: 'Public Event' },
] as const;

export type CategoryId = (typeof CATEGORIES)[number]['id'];

export const CATEGORY_IDS = CATEGORIES.map((c) => c.id) as unknown as readonly CategoryId[];

/**
 * Subcategories for specific categories (e.g., Administrative).
 */
export const SUBCATEGORIES = {
  administrative: [
    { id: 'general', label: 'General' },
    { id: 'bod_meeting', label: 'BOD Meeting' },
    { id: 'company_meeting', label: 'Company Meeting' },
  ],
} as const;

export type AdminSubcategoryId = (typeof SUBCATEGORIES.administrative)[number]['id'];
export type SubcategoryId = AdminSubcategoryId;

export function getSubcategoriesForCategory(category: CategoryId): readonly { id: string; label: string }[] | null {
  return (SUBCATEGORIES as Record<string, readonly { id: string; label: string }[]>)[category] ?? null;
}

/**
 * Shift types for time entries (SDD §4.1).
 */
export const SHIFT_TYPES = [
  { id: 'scheduled', label: 'Scheduled' },
  { id: 'swap', label: 'Swap' },
  { id: 'extra', label: 'Extra' },
  { id: 'makeup', label: 'Makeup' },
  { id: 'migrated', label: 'Migrated' },
] as const;

export type ShiftTypeId = (typeof SHIFT_TYPES)[number]['id'];

export const SHIFT_TYPE_IDS = SHIFT_TYPES.map((s) => s.id) as unknown as readonly ShiftTypeId[];

/**
 * Time entry sources (SDD §4.1).
 */
export const SOURCES = ['app', 'officer', 'admin', 'migration'] as const;
export type SourceId = (typeof SOURCES)[number];
